import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from "UI/Dropdown";
import { ExternalLinkIcon, PlayIcon, PencilAltIcon, CogIcon, TrashIcon, EyeIcon, DocumentDuplicateIcon } from "@heroicons/react/outline";
import Feature from "Components/Feature";

export default class StoryCardSettingsMenu extends React.Component
{
    static propTypes = {
        story: PropTypes.object.isRequired,

        onSettings: PropTypes.func.isRequired,
        onPublish: PropTypes.func.isRequired,
        onDuplicate: PropTypes.func.isRequired,
        onCreatePosts: PropTypes.func.isRequired,
        onDelete: PropTypes.func.isRequired,
    };

    render()
    {
        const { story } = this.props;

        return <Dropdown button={Dropdown.VerticalDotsButton} origin='tl'>
            <Dropdown.LinkItem to={`/stories/${story.id}/edit`}>
                <PencilAltIcon className='h-4 w-auto' />
                <span>Edit</span>
            </Dropdown.LinkItem>
            <Dropdown.LinkItem to={`/stories/${story.id}`}>
                <PlayIcon className='h-4 w-auto' />
                <span>Preview</span>
            </Dropdown.LinkItem>
            <Dropdown.Item onClick={this.props.onCreatePosts}>
                <ExternalLinkIcon className='h-4 w-auto' />
                <span>Create Post</span>
            </Dropdown.Item>
            <Dropdown.Item onClick={this.props.onPublish}>
                <EyeIcon className='h-4 w-auto' />
                <span>Publish</span>
            </Dropdown.Item>
            <Dropdown.Item onClick={this.props.onDuplicate}>
                <DocumentDuplicateIcon className='h-4 w-auto' />
                <span>Duplicate</span>
            </Dropdown.Item>
            <Dropdown.Item onClick={this.props.onSettings}>
                <CogIcon className='h-4 w-auto' />
                <span>Manage Story</span>
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item danger onClick={this.props.onDelete}>
                <TrashIcon className='h-4 w-auto' />
                <span>Delete</span>
            </Dropdown.Item>

        </Dropdown>
    }
}
